module.exports = __webpack_public_path__ + "media/question4_au.1443b0c0.mp3";